import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminNetworksScreen from "../../../container/RateAdminScreen/RateAdminNetworksScreen";
import CreateRateAdminNetworks from "../../../container/RateAdminScreen/RateAdminNetworksScreen/CreateRateAdminNetworks";

const RateAdminNetworksRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_NETWORK.HOME}
          element={<RateAdminNetworksScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_NETWORK.CREATE}
          element={<CreateRateAdminNetworks />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_NETWORK.EDIT}
          element={<CreateRateAdminNetworks isEdit={true} />}
        />
      )}
    </>
  );
};

export default RateAdminNetworksRoutes;
